import { Component, Input } from '@angular/core';
import { BaseConfirmationDialogComponent } from '../../../../lib/components/dialogs/base-confirmation-dialog.component';

@Component({
  selector: 'boi-hard-credit-warning-dialog',
  templateUrl: './hard-credit-warning-dialog.component.html',
  styleUrls: ['./hard-credit-warning-dialog.component.scss']
})
export class HardCreditWarningDialogComponent extends BaseConfirmationDialogComponent<void> {
  @Input() warningLabel = this.referenceDataLabels.BOHardCreditWarning;
  @Input() warningContentLabel = this.referenceDataLabels.BOHardCreditWarningContent;
}
